import memoji1 from "./assets/memoji1.png"; //male
import memoji2 from "./assets/memoji2.png"; //female
import memoji3 from "./assets/memoji3.png";
import memoji4 from "./assets/memoji4.png";
import memoji5 from "./assets/memoji5.png";
import memoji1Chat from "./assets/memoji1-chat.png"; //male
import memoji2Chat from "./assets/memoji2-chat.png"; //female
import memoji3Chat from "./assets/memoji3-chat.png";
import memoji4Chat from "./assets/memoji4-chat.png";
import memoji5Chat from "./assets/memoji5-chat.png";
import baristamemoji from "./assets/barista_memoji.png";
import {
  Calendar,
  CreditCard,
  User2,
  PhoneIcon,
  Umbrella,
  Bell,
  Plane,
  User,
  Mail,
  Smartphone,
  SpeakerIcon,
  Camera,
  Headphones,
  Watch,
  Sofa,
  Phone,
  Home,
  IdCardIcon,
  BadgeDollarSign,
  ReceiptIcon,
  IdCard,
  CalendarCheckIcon,
  BadgeCheckIcon,
  PhoneCall,
  Tv,
  Dot
} from "lucide-react";
import {
  VOICEX_URL_CONSTANTS,
  DEFAULT_TENANT_ID,
  DEFAULT_WORKSPACE_ID,
  DEFAULT_USER_ID,
  OLD_TENANT_ID,
  OLD_WORKSPACE_ID,
  OLD_USER_ID,
  STAGE_TENANT_ID,
  STAGE_WORKSPACE_ID,
  STAGE_USER_ID,
  US_TENANT_ID,
  US_WORKSPACE_ID,
  US_USER_ID,
  NURIX_TENANT_ID,
  NURIX_WORKSPACE_ID
} from "./utils/constants";

export const agentCategories = {
  // Insurance: {
  //   path: "/insurance",
  //   pageTitle: "Experience Our Insurance Agents",
  //   agents: [
  //     {
  //       id: "30cd0024-fafd-4f21-9139-54bef97bd21d",
  //       name: "Home Insurance FNOL",
  //       agentName: "Sarah",
  //       icon: memoji4,
  //       chatIcon: memoji4Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Claimant name", value: "John Doe" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "555-123-4567" },
  //         { icon: Umbrella, name: "Policy Number", value: "NRX-1234" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     }
  //   ]
  // },
  InsurancePandC: {
    path: "/insurance/pandc",
    pageTitle: "Experience Our P&C Insurance Agents",
    agents: [
      {
        id: "0ab93b94-b9d9-43ba-8ba3-89e1c7354fc4",
        name: "Auto Insurance Renewal",
        agentName: "Ethan",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Sales Qualification",
          "Policy Updates Collection",
          "Renewal Reminders"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "28d274aa-5cbb-4ba7-b07d-80da5dae877c",
        name: "Auto Sales Qualification",
        agentName: "Marissa",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "fa952839-4cc2-4290-b2d6-a7f9684ab85d",
        name: "Auto-Ask your Policy",
        agentName: "Emily",
        icon: memoji3,
        chatIcon: memoji3Chat,
        featureList: ["Answering queries", "Upgrading policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: User2, name: "Last four digits of SSN", value: "5478" },
          { icon: Calendar, name: "DOB", value: "19th February 1986" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "9c327671-c195-44c9-8729-9273184348ed",
        name: "Home-Ask your Policy",
        agentName: "Myra",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Answering queries", "Upgrading policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: User2, name: "Last four digits of SSN", value: "5478" },
          { icon: Calendar, name: "DOB", value: "19th February 1986" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "30cd0024-fafd-4f21-9139-54bef97bd21d",
        name: "Home Insurance FNOL",
        agentName: "Sarah",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Register home damage claim", "Collect incident details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { icon: User2, name: "Claimant name", value: "John Doe" },
          { icon: PhoneIcon, name: "Phone Number", value: "555-123-4567" },
          { icon: Umbrella, name: "Policy Number", value: "NRX-1234" },
          { icon: Bell, name: "OTP", value: "123456" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  InsuranceHealthCare: {
    path: "/insurance/healthcare",
    pageTitle: "Experience Our Health Insurance Agents",
    agents: [
      {
        id: "80823e8e-afa8-4098-83fd-2d1c5ca40060",
        name: "Ask Your Policy",
        agentName: "Myra",
        icon: memoji3,
        chatIcon: memoji3Chat,
        featureList: [
          "Clarify details of your policy",
          "Explain payment breakdown"
        ],
        voice: "true",
        chat: "true",
        chatHints: [
          { triggers: ["full name"], hint: "Full name: Alex Smith" },
          {
            triggers: ["date of birth", "janm date", "birth date"],
            hint: "Date of Birth: February 15, 1989"
          }
        ],
        callHints: [
          { icon: User2, name: "User Name", value: "Alex Smith" },
          { icon: Calendar, name: "User DOB", value: "February 15, 1989" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "205cd6f2-79ad-4a2b-b3dd-d927b6359055",
        name: "Insurance Sales",
        agentName: "Merissa",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Assess customer needs", "Suggest best suited policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  "Insurance-sub-category": {
    path: "/insurance/sub-category",
    pageTitle: "Experience Our Insurance Agents",
    agents: [],
    subCategories: ["1", "2"]
  },
  "Insurance-Es": {
    path: "/insurance/spanish",
    pageTitle: "Experience Our Insurance Agents",
    agents: [
      {
        id: "b945e29c-6b8d-48f5-997f-06080d2a5812",
        name: "Home Insurance FNOL",
        agentName: "Sarah",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Register home damage claim", "Collect incident details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { icon: User2, name: "Claimant name", value: "Juan Fernández" },
          { icon: PhoneIcon, name: "Phone Number", value: "555-123-4567" },
          { icon: Umbrella, name: "Policy Number", value: "NRX-1234" },
          { icon: Bell, name: "OTP", value: "123456" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "d6168221-ec07-4840-8d17-79ca4d9d2f27",
        name: "Ask Your Policy",
        agentName: "Myra",
        icon: memoji3,
        chatIcon: memoji3Chat,
        featureList: [
          "Clarify details of your policy",
          "Explain payment breakdown"
        ],
        voice: "true",
        chat: "false",
        chatHints: [
          { triggers: ["full name"], hint: "Full name: Juan Fernández" },
          {
            triggers: ["date of birth", "janm date", "birth date"],
            hint: "Date of Birth: February 15, 1989"
          }
        ],
        callHints: [
          { icon: User2, name: "User Name", value: "Juan Fernández" },
          { icon: Calendar, name: "User DOB", value: "February 15, 1989" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "ef182220-61bc-445a-b912-9479ec977849",
        name: "Insurance Sales",
        agentName: "Merissa",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Assess customer needs", "Suggest best suited policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Travel: {
    path: "/travel",
    pageTitle: "Experience Our Travel Agents",
    agents: [
      {
        id: "c0af35a9-1c17-45ab-9fca-63be1ebd60b0",
        name: "Flight Rescheduling",
        agentName: "Myra",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Reschedule flight", "Answer basic FAQs"],
        voice: "true",
        chat: "true",
        chatHints: [
          { triggers: ["pnr"], hint: "PNR: ABC123" },
          {
            triggers: ["last name"],
            hint: "Last name: Johnson"
          },
          {
            triggers: ["otp"],
            hint: "OTP: 123456"
          }
        ],
        callHints: [
          { icon: Plane, name: "PNR", value: "ABC123" },
          { icon: User, name: "Last name", value: "Johnson" },
          { icon: Bell, name: "OTP", value: "123456" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Hospitality: {
    path: "/hospitality",
    pageTitle: "Experience Our Hospitality Agents",
    agents: [
      {
        id: "2cf83ca7-4204-47cb-940d-70e5237aa46f",
        name: "Room Booking",
        agentName: "Victoria",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [
          "Handle room booking",
          "Answer property FAQs",
          "Travel and Spa booking"
        ],
        voice: "true",
        chat: "true",
        chatHints: [
          { triggers: ["name"], hint: "Name: John Atkins" },
          {
            triggers: ["email"],
            hint: "Email: john@gmail.com"
          }
        ],
        callHints: [
          { icon: User2, name: "Name", value: "John Atkins" },
          { icon: Mail, name: "Email", value: "john@gmail.com" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Retail: {
    path: "/retail",
    pageTitle: "Experience Our Retail Agents",
    agents: [
      {
        id: "c6479ac8-feac-4b19-943f-c1f4099e5988",
        name: "Order Tracking & Return",
        agentName: "Alice",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [
          "Track/Cancel order",
          "Change delivery instructions",
          "Exchange and refund status",
          "Return order"
        ],
        voice: "true",
        chat: "true",
        chatHints: [
          {
            triggers: ["name or order id"],
            hint: "Order ID: 202, Name: Bluetooth Speaker"
          },
          {
            triggers: ["how may i help you today?"],
            hint: "Ask it to fetch details of all orders, delivery status, etc..."
          }
        ],
        callHints: [
          { icon: SpeakerIcon, name: "Bluetooth Speaker", value: "ID: #202" },
          { icon: Camera, name: "Security Camera ", value: "ID: #456" },
          { icon: Smartphone, name: "Smartphone Case ", value: "ID: #789" },
          { icon: Headphones, name: "Headphones", value: "ID: #123" },
          { icon: Watch, name: "Smart Watch", value: "ID: #101" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "2e7a74d6-fd3b-4b23-80e6-5a3db7596deb",
        name: "Reward Supports Agent",
        agentName: "Maya",
        icon: memoji3,
        chatIcon: memoji3Chat,
        featureList: [
          "Star Rewards Inquiry",
          "Star calculation elucidation",
          "Reward issue resolution"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: Phone, name: "Phone number", value: "202 555 0123" },
          { name: "Recommendations For Testing :-" },
          { icon: Dot, name: "Track Missing Stars" },
          { icon: Dot, name: "Star Calculation Help" },
          { icon: Dot, name: "Offer Activation Guidance" },
          { icon: Dot, name: "Delayed Star Resolution" },
          { icon: Dot, name: "Redeem Rewards" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "d25890ec-1766-4467-94ed-867378088ff0",
        name: "Customer Service Representative",
        agentName: "Myra",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["Taking orders", "Scheduling Pickup"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "c04bc7d7-1c73-4d0a-aff1-ed591aa44b58",
        name: "Vendor Support Representative",
        agentName: "Alex",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Payment due",
          "Pending documents to be uploaded",
          "Shipment delay"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { name: "Vendor Name", value: "ABC Traders" },
          { name: "Vendor ID ", value: "ABCT-0912" },
          {
            name: "Last four digits of phone number ",
            value: "9123"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Banking: {
    path: "/banking",
    pageTitle: "Experience Our Banking Agents",
    agents: [
      {
        id: "ee9f7689-d7f3-41c1-91d4-0c2ab3c435f4",
        name: "Collections Agent",
        agentName: "Maria",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Remind users to pay overdue"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: User, name: "Name of User", value: "Mr Robin Smith" },
          { icon: CreditCard, name: "Social security code", value: "3456" },
          { icon: Calendar, name: "Date of Birth", value: "2nd Jan 1998" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "66a12d61-5a52-4c28-a620-b576890fa9bc",
        name: "Banking Customer Support",
        agentName: "Emily",
        icon: memoji3,
        chatIcon: memoji3Chat,
        featureList: [
          "Account transaction support",
          "Credit card transaction support",
          "Credit card upgradation and modification",
          "Language: English"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: IdCard, name: "Last four digits of SSN", value: "5439" },
          {
            icon: CreditCard,
            name: "Last Four digits of Bank Account",
            value: "5438"
          },
          {
            icon: Calendar,
            name: "Last Four digits of Credit Card:",
            value: "1532"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "5dd78249-ffb2-4878-9bd9-451ce1bb8145",
        name: "Mortgage Sales Agent",
        agentName: "Marissa",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [
          "Suggest Best  suited Home Mortgage",
          "Query resolution related to Home Mortgage",
          "Language: English"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Default: {
    path: "/*",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "3a0b5e40539697108263058dbaff9277",
        name: "Banking Customer Support",
        agentName: "Pranav",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Bank account inquiry",
          "Lost credit card reporting",
          "Card limit modification"
        ],
        voice: "true",
        chat: "true",
        chatHints: [
          { triggers: ["last 4 digits"], hint: "Account No. ••• •••••• 1234" },
          {
            triggers: ["date of birth", "janm date", "birth date"],
            hint: "Date of Birth 01/02/2000"
          }
        ],
        callHints: [
          { icon: Calendar, name: "Date of Birth", value: "01/02/2000" },
          { icon: CreditCard, name: "Account No.", value: "••• •••••• 1234" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "agent_7e1679684cd8b087cf1151bc0f",
        name: "Insurance Sales Outreach",
        agentName: "Simran",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Health insurance policy suggestions",
          "Policy breakdown and comparison",
          "Policy terms elucidation"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },

  Starbucks: {
    path: "/starbucks",
    pageTitle: "Experience Our Starbucks Agent",
    agents: [
      {
        id: "08a89600-007c-4766-9309-6f2f5d12bc51",
        name: "Rewards Support Agent",
        agentName: "Maya",
        icon: baristamemoji,
        chatIcon: memoji1Chat,
        featureList: [
          "Star Rewards Inquiry",
          "Star calculation elucidation",
          "Reward issue resolution"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },

  Renegade: {
    path: "/renegade",
    pageTitle: "Experience Our Insurance Agent",
    agents: [
      {
        id: "",
        name: "Insurance Support Agent",
        agentName: "Rachel",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Verify identity with phone number",
          "Locate policy information",
          "Document queries for follow-up"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: [],
        voiceProvider: "livekit",
        voiceConfig: {
          tokenUrl: "https://renegade.stage.nurixlabs.tech/token",
          user_id: DEFAULT_USER_ID,
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        },
        chatHints: [],
        callHints: [
          { icon: Phone, name: "Test Number 1", value: "832-512-5522" },
          { icon: Phone, name: "Test Number 2", value: "215-928-3252" },
          { icon: Phone, name: "Test Number 3", value: "386-566-6029" }
        ],
        callHintsTable: []
      }
    ]
  },

  Cult: {
    path: "/cult",
    pageTitle: "Experience Our Fitness Agent",
    agents: [
      {
        id: "",
        name: "Fitness Consultant",
        agentName: "Simran",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Personalized workout plans",
          "Fitness goal tracking",
          "Nutrition guidance"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: [],
        voiceProvider: "livekit",
        voiceConfig: {
          tokenUrl: "https://cult-voice.stage.nurixlabs.tech/token",
          user_id: DEFAULT_USER_ID,
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        },
        chatHints: [],
        callHints: [],
        callHintsTable: []
      }
    ]
  },

  Flipkart: {
    path: "/delivery-agents",
    pageTitle: "Experience our Retail AI Agents",
    agents: [
      {
        id: "a0f5087d-800c-488b-9ba7-91471e30918a",
        name: "Order and Refund tracking",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Default order: Speakers", "Language: English"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [
          { icon: SpeakerIcon, name: "Item", value: "Bluetooth Speaker" },
          {
            icon: Calendar,
            name: "Date",
            value: "25th October 2024"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
        name: "Installation reschedule",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Default order: Sofa", "Language: Hindi"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [
          { icon: Sofa, name: "Item", value: "Sofa" },
          {
            icon: Calendar,
            name: "Date",
            value: "26th October 2024"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "0f02f7a6-c949-415c-83e3-9df6178140ac",
        name: "Delivery and Installation reschedule",
        agentName: "Monica",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Default order: Sofa and speakers", "Language: English"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [
          { icon: Sofa, name: "Item", value: "Sofa" },
          {
            icon: Calendar,
            name: "Date",
            value: "26th October 2024"
          },
          { icon: SpeakerIcon, name: "Item", value: "Bluetooth Speaker" },
          {
            icon: Calendar,
            name: "Date",
            value: "25th October 2024"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },

  Test: {
    path: "/test",
    pageTitle: "Experience Our Test Agents",
    agents: [
      {
        id: "035bb0f7-d4c7-4f06-8b7b-e6aeff20c61d",
        name: "Nuplay Agent",
        agentName: "Nuplay",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "true",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "bb0abe4d-88c3-40da-ba3c-e744308dfd7f",
        name: "Nuplay Agent",
        agentName: "Nuplay",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "true",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  TC: {
    path: "/tc",
    pageTitle: "Experience Our Agents",
    agents: [
      {
        id: "42e58791-24aa-4a24-b7ba-dce54198f4d7",
        name: "Personal Loan Welcome Call",
        agentName: "Riya",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Welcome email after loan confirmation",
          "Customer verification",
          "Sharing valuable information"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: Calendar, name: "DOB", value: "12-June-1998" },
          {
            icon: Home,
            name: "Address",
            value: "204, Ashok Tower, 18th road, Khar West, Mumbai, 400052"
          },
          { icon: IdCardIcon, name: "PAN", value: "EBYSG7668F" },
          {
            icon: BadgeDollarSign,
            name: "Sanctioned Amount",
            value: "INR 5,00,000"
          },
          { icon: ReceiptIcon, name: "EMI Amount", value: "INR 16,181" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  AIG: {
    path: "/aig",
    pageTitle: "Experience Our TATA AIG Agents",
    agents: [
      {
        id: "ed112f23-0563-41f4-8f79-d229fd8c19fb",
        name: "Service Request for Endorsement",
        agentName: "Monica",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: IdCard, name: "Customer's Name", value: "Aayush Sharma" },
          { icon: CalendarCheckIcon, name: "DOB", value: "2nd February, 2000" },
          { icon: BadgeCheckIcon, name: "Policy Number", value: "****1234" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "4ade6bd7-82ef-4b33-a160-ca110c7b133a",
        name: "Sales and Renewal for Two-wheeler",
        agentName: "Robin",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  "AIG-NURIX": {
    path: "/insurance-nurix",
    pageTitle: "Experience Our Nuplay Agents",
    agents: [
      {
        id: "26f9f2bc-01d5-46bf-a87a-251da5bfed77",
        name: "Sales and Renewal for Two-wheeler",
        agentName: "Robin",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  IndianFinancialInstitution: {
    path: "/indian-financial-institution",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "d7de52b6-5734-45a6-83ec-6e7ef6655244",
        name: "Loan Qualification Agent",
        agentName: "Arjun",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["personal loan enquiry", "checking eligibility"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "d7de52b6-5734-45a6-83ec-6e7ef6655244",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  BirlaCapital: {
    path: "/aditya-birla-capital",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "d7de52b6-5734-45a6-83ec-6e7ef6655244",
        name: "Loan Qualification Agent",
        agentName: "Arjun",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["personal loan enquiry", "checking eligibility"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "d7de52b6-5734-45a6-83ec-6e7ef6655244",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  Cliniq360: {
    path: "/cliniq360",
    pageTitle: "Experience Our Cliniq360 Agent",
    agents: [
      {
        id: "dd0c56a0-168b-492a-8c2c-4fba5dd566f6",
        name: "Claim Status Helpline",
        agentName: "Harsh",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Language: English"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [
          {
            "Policy Number": "145234",
            "Patient Name": "Tina Sharma",
            relative: "Maya Sharma",
            relation: "Sister of Tina"
          },
          {
            "Policy Number": "212432",
            "Patient Name": "Pooja Singh",
            relative: "Ramesh Singh",
            relation: "Husband of Pooja"
          },
          {
            "Policy Number": "545621",
            "Patient Name": "Suman Verma",
            relative: "Neha Verma",
            relation: "Daughter of Suman"
          }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Cliniq360VoiceX: {
    path: "/cliniq360-voicex",
    pageTitle: "Experience Our Cliniq360 Agent",
    agents: [
      {
        id: "",
        name: "Claim Status Helpline",
        agentName: "Harsh",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Language: English"],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "bc746433-06e8-4e81-bf9d-5f40e58d2e20",
          overide_previous_context: true,
          custom_data: {},
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        },
        chatHints: [],
        callHintsTable: [
          {
            "Policy Number": "145234",
            "Patient Name": "Tina Sharma",
            relative: "Maya Sharma",
            relation: "Sister of Tina"
          },
          {
            "Policy Number": "212432",
            "Patient Name": "Pooja Singh",
            relative: "Ramesh Singh",
            relation: "Husband of Pooja"
          },
          {
            "Policy Number": "545621",
            "Patient Name": "Suman Verma",
            relative: "Neha Verma",
            relation: "Daughter of Suman"
          }
        ],
        callHints: []
      }
    ]
  },
  Myntra: {
    path: "/myntra",
    pageTitle: "E-commerce Voice Agents",
    agents: [
      {
        id: "bb11cf4b-85cc-4fc4-8c8f-4162e5642947",
        name: "Refund status",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Language: Hinglish",
          "Task : Refund status on cancelled order",
          "Task : Refund status on Picked up Return"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "5d24b946-18d5-4e41-9702-4d6255da611e",
        name: "Order tracking",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Language: Hinglish",
          "Task : Order Status",
          "Task : Modify Order"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [
          {
            icon: Calendar,
            name: "Date",
            value: "27th January 2025"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },

  EcommerceRefund: {
    path: "/ecommerce-refund",
    pageTitle: "E-commerce Voice Agents",
    agents: [
      {
        id: "bb11cf4b-85cc-4fc4-8c8f-4162e5642947",
        name: "Refund status",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Language: Hinglish",
          "Task : Refund status on cancelled order",
          "Task : Refund status on Picked up Return"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [
          {
            icon: PhoneCall,
            name: "Phone number",
            value: "1234567890"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },

  MyntraVoiceX: {
    path: "/myntra-voicex",
    pageTitle: "E-commerce Voice Agents",
    agents: [
      {
        id: "db35e97e-f46d-4a34-894f-7ee985cc4001",
        name: "Refund status",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Language: Hinglish",
          "Task : Refund status on cancelled order",
          "Task : Refund status on Picked up Return"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "ef7701ea-7168-42e2-931f-cbd6a0c6f304",
          overide_previous_context: true,
          custom_data: {},
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        }
      },
      {
        id: "5d24b946-18d5-4e41-9702-4d6255da611e",
        name: "Order tracking",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Language: Hinglish",
          "Task : Order Status",
          "Task : Modify Order"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [
          {
            icon: Calendar,
            name: "Date",
            value: "27th January 2025"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "5af97ec2-602c-4432-8783-0262bc84dcd5",
          overide_previous_context: true,
          custom_data: {},
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        }
      }
    ]
  },
  Recruitment: {
    path: "/recruitment",
    pageTitle: "Recruitment Voice Agents",
    agents: [
      {
        id: "18f5767c-2de8-4ea9-9827-77e90eb9bc57",
        name: "Recruitment Agent",
        agentName: "Emily",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Provides Job Details",
          "Efficiently Schedules Interviews",
          "Enhances Applicant Engagement"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Recruitment_voicex: {
    path: "/recruitment-voicex",
    pageTitle: "Recruitment Voice HR Agents",
    agents: [
      {
        id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
        name: "Recruitment HR Agent",
        agentName: "Lisa",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Basic candidate details matching",
          "Efficient interview scheduling",
          "Improved applicant engagement"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "b7ad9ecc-b5f1-41be-a92a-c2abd9daaf3a",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        }
      }
    ]
  },
  delivery_agents_voicex: {
    path: "/delivery-agents-voicex",
    pageTitle: "Experience our Retail AI Agents",
    agents: [
      {
        id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
        name: "Installation Reschedule",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Language: English", "Task : Installation Reschedule"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [
          { icon: Sofa, name: "Item", value: "Sofa" },
          {
            icon: Calendar,
            name: "Date",
            value: "26th October 2024"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "b2b9f0e2-9808-442f-9a47-948a88739b88",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        }
      },
      {
        id: "a0f5087d-800c-488b-9ba7-91471e30918a",
        name: "Delivery Attempt",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Delivery Attempt"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [
          { icon: SpeakerIcon, name: "Item", value: "Bluetooth Speaker" },
          {
            icon: Calendar,
            name: "Date",
            value: "25th October 2024"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "2ddb87b7-5f74-4769-8435-e73b102a137b",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        }
      }
    ]
  },

  InsuranceSales: {
    path: "/insurance-sales",
    pageTitle: "Experience Our Insurance Sales Agents",
    agents: [
      {
        id: "93556190-f084-4669-af54-649b815da3d0",
        name: "Insurance Sales Agent",
        agentName: "Sarah",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Assess customer needs",
          "Suggest best suited policy update"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  PolicyRenewal: {
    path: "/policy-renewal",
    pageTitle: "Experience Our Policy Renewal Agents",
    agents: [
      {
        id: "11b89b58-b001-488a-8f13-893eab318614",
        name: "Policy Renewal Agent",
        agentName: "Jennifer",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Assist with Policy Renewals", "Answer Customer Queries"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },

  elevatenowVoicex: {
    path: "/elevate-voicex",
    pageTitle: "Experience Our Healthcare AI Agents",
    agents: [
      {
        id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
        name: "Weight Loss Goal",
        agentName: "Priya",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Language: English",

          "Task : Sell Nano Pack"
          // "TTS: Elevenlabs"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "eb3e5f11-a77f-4346-83bf-5fc691a2743d",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: OLD_TENANT_ID,
          workspace_id: OLD_WORKSPACE_ID
        }
      }
    ]
  },
  registerKaroVoicex: {
    path: "/registerkaro-voicex",
    pageTitle: "Experience Our Compliance AI Agents",
    agents: [
      {
        id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
        name: "Register Karo Agent",
        agentName: "Rohit",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Language: Hinglish",

          "Task : Business Compliance Registration"
          // "TTS: Elevenlabs"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "c6726cb6-3b8a-482d-9368-bdb9d1bdd35a",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: "a87466d3-f416-4b5a-a923-84d2273d15d5",
          workspace_id: "a87466d3-f416-4b5a-a923-84d2273d15d5"
        }
      }
    ]
  },
  dela: {
    path: "/dela",
    pageTitle: "Experience our AI Agent",
    agents: [
      {
        id: "a75ec487-32ba-4fc2-8b51-9f7fcc6ca484",
        name: "Dela - Email ID Collection",
        agentName: "Olivia",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Collect email information", "Verify contact details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { icon: User2, name: "User Name", value: "John" },
          { icon: Calendar, name: "Date of Birth", value: "3rd January 1985" },
          { icon: Mail, name: "Email", value: "John@gmail.com" },
          { icon: User, name: "Family Member", value: "Helena (Wife)" },
          { icon: Mail, name: "Family Email", value: "Helena@gmail.com" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  realestate: {
    path: "/realestate",
    pageTitle: "Experience our AI Agent",
    agents: [
      {
        id: "fa441586-b41e-4756-abd5-f4435a8f126d",
        name: "Lead Qualification Agent",
        agentName: "Barbara",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  frontlineVoicex: {
    path: "/frontline-voicex",
    pageTitle: "Experience AI-powered Voice Dental Health Agent",
    agents: [
      {
        id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
        name: "Dental Agent",
        agentName: "Lisa",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: English"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: OLD_USER_ID,
          agent_id: "17b3d578-2a79-4563-8386-73a40fac5265",
          overide_previous_context: true,
          custom_data: { name: "Kenny" },
          webhook_customer_id: "experience-page",
          tenant_id: OLD_TENANT_ID,
          workspace_id: OLD_WORKSPACE_ID
        }
      }
    ]
  },
  niceActimizeVoicex: {
    path: "/nice-voicex",
    pageTitle: "Experience AI-powered Voice Sales Agent",
    agents: [
      {
        id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
        name: "Sales Agent",
        agentName: "Suzi",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: English"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: OLD_USER_ID,
          agent_id: "dd0d01be-94ae-42f0-8bb0-6e56be045bad",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: OLD_TENANT_ID,
          workspace_id: OLD_WORKSPACE_ID
        }
      }
    ]
  },
  momentumVoicex: {
    path: "/momentum-voicex",
    pageTitle: "Experience Our Momentum Now Agent",
    agents: [
      {
        id: "",
        name: "Momentum Sales Agent",
        agentName: "Rachel",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          tenant_id: OLD_TENANT_ID,
          workspace_id: OLD_WORKSPACE_ID,
          agent_id: "47e86c25-7206-494b-b6a6-e25d2031aa4e"
        },
        chatHints: [],
        callHints: [],
        callHintsTable: []
      }
    ]
  },
  elevatenowVoicexOriginal: {
    path: "/elevate-voicex-original",
    pageTitle: "Experience Our Healthcare AI Agents",
    agents: [
      {
        id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
        name: "Weight Loss Goal",
        agentName: "Priya",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: English", "Task : Sell Nano Pack"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "383209ba-2ec2-41d4-bda7-892f637368c7",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: "67005259-6ca4-464e-828a-f3637e80c1d8",
          workspace_id: "67005259-6ca4-464e-828a-f3637e80c1d8"
        }
      }
    ]
  },
  Lloyd: {
    path: "/lloyd",
    pageTitle: "Experience Our Lloyd Agents",
    agents: [
      {
        id: "a8c74223-2600-468f-ab43-d64b81900b24",
        name: "Home Insurance FNOL",
        agentName: "Sarah",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Register home damage claim", "Collect incident details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { icon: User2, name: "Claimant name", value: "Brian Jason Smith" },
          {
            icon: Mail,
            name: "Email",
            value: "Brian.Jason.Smith@charlestaylor.com"
          },
          { icon: PhoneIcon, name: "Phone Number", value: "+44 20 3320 8888" },
          { icon: Bell, name: "OTP", value: "123456" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  ConnectAndHeal: {
    path: "/connectandheal",
    pageTitle: "Experience Our Healthcare Agent",
    agents: [
      {
        id: "b2d4f6a8-6460-4f53-bc48-82eca7e958ac",
        name: "Customer Care Agent",
        agentName: "Arjun",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Book doctor consultations",
          "Reschedule existing appointments",
          "Provide available slots and doctor recommendations"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { icon: PhoneIcon, name: "Existing Customer", value: "23456789" },

          { icon: PhoneIcon, name: "New Customer", value: "434567890" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  // elevatenowVoicexGoogleTTS: {
  //   path: "/elevate-voicex-googltts",
  //   pageTitle: "Experience Our Healthcare AI Agents",
  //   agents: [
  //     {
  //       id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
  //       name: "Weight Loss Goal",
  //       agentName: "Priya",
  //       icon: memoji2,
  //       chatIcon: memoji1Chat,
  //       featureList: ["Language: English", "Task : Sell Nano Pack"],
  //       voice: "true",
  //       chat: "false",
  //       demo: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       voiceInputs: [],
  //       voiceProvider: "voicex",
  //       voiceConfig: {
  //         baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
  //         user_id: OLD_USER_ID,
  //         agent_id: "e1ac102d-1124-11f0-8ad9-02a4509d8f83",
  //         overide_previous_context: true,
  //         custom_data: {},
  //         webhook_customer_id: "experience-page",
  //         tenant_id: OLD_TENANT_ID,
  //         workspace_id: OLD_WORKSPACE_ID
  //       }
  //     }
  //   ]
  // },

  // MyntryAgent: {
  //   path: "/myntra-agent",
  //   pageTitle: "Experience Our Myntra Agent",
  //   agents: [
  //     {
  //       id: "0ff30a71-f1c6-4047-9c74-25de886ad2a7",
  //       name: "Delivery and Return Agent",
  //       agentName: "Myra",
  //       icon: memoji2,
  //       chatIcon: memoji1Chat,
  //       featureList: [
  //         "Language: Hinglish",
  //         "Task : Delivery and Return related"
  //       ],
  //       voice: "true",
  //       chat: "false",
  //       demo: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       voiceInputs: [],
  //       voiceProvider: "voicex",
  //       voiceConfig: {
  //         baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
  //         user_id: DEFAULT_USER_ID,
  //         agent_id: "",
  //         overide_previous_context: true,
  //         custom_data: {},
  //         webhook_customer_id: "experience-page",
  //         tenant_id: DEFAULT_TENANT_ID,
  //         workspace_id: DEFAULT_WORKSPACE_ID
  //       }
  //     }
  //   ]
  // },

  RetailMultilingual: {
    path: "/retailmultilingual",
    pageTitle: "Experience Our Retail Agents",
    agents: [
      {
        id: "13198f26-538f-4ffe-b2c2-392759afc1f6",
        name: "Order Tracking & Return",
        agentName: "Ayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Order tracking",
          "Return and exchange status",
          "Language: Hinglish"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: SpeakerIcon, name: "Bluetooth Speaker", value: "ID: 1234" },
          { icon: Watch, name: "Polo Tshirt", value: "ID: 1235" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "d12007db-627d-434e-9fc4-2a28c3d7bd0b",
        name: "Refund Status And Order Cancellation ",
        agentName: "Ayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Refund status", "Order cancellation", "Language: Hindi"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: Sofa, name: "Sofa" },
          { icon: Tv, name: "Samsung TV " }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "13921176-2d4f-4571-9755-3ea91cdafb0e",
        name: "Delivery And Installation Reschedule",
        agentName: "Monica",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["Delivery and installation inquiry", "Language: English"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: Camera, name: "Samsung TV " },
          { icon: SpeakerIcon, name: "Bluetooth Speaker " }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Staffing: {
    path: "/staffing",
    pageTitle: "Experience Our Staffing and Recruiting Agents",
    agents: [
      {
        id: "561c9c4a-2645-4821-8cbd-712d1773b921",
        name: "Pre-Screening Agent",
        agentName: "Emily",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: [
          "Provide Job Details",
          "Efficiently schedules interviews",
          "Enhances Applicant Enhancement"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  elevatenowVoicexOutbound: {
    path: "/elevate-voicex-outbound",
    pageTitle: "Experience Our Healthcare AI Agents",
    agents: [
      {
        id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
        name: "Weight Loss Goal",
        agentName: "Priya",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: English", "Task : Sell Nano Pack"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "383209ba-2ec2-41d4-bda7-892f637368c7",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: "67005259-6ca4-464e-828a-f3637e80c1d8",
          workspace_id: "67005259-6ca4-464e-828a-f3637e80c1d8"
        }
      }
    ]
  },
  Education: {
    path: "/education",
    pageTitle: "Experience Our Education Agent",
    agents: [
      {
        id: "7cf0b61d-c332-49f5-a10e-0090488cf272",
        name: "Education Support Agent",
        agentName: "Sarah",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["FAQ agent", "Appointment Scheduling for school visit"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Falabella: {
    path: "/falabella",
    pageTitle: "Experience Our Falabella Agent",
    agents: [
      {
        id: "aabee0aa-4ad4-4e93-aec6-adc846976db1",
        name: "Ask Your Policy",
        agentName: "Camilla",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Clarify details of your policy"],
        voice: "false",
        chat: "true",
        chatHints: [
          {
            triggers: ["fecha de nacimiento", "nacimiento", "RUT"],
            hint: "Date Of Birth: 03/01/1989 , RUT: 12345678K"
          }
        ],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },

      {
        id: "1177be29-2e08-43f3-87ed-1d001b7b6446",
        name: "Ask Your Policy",
        agentName: "Camilla",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Clarify details of your policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { icon: IdCardIcon, name: "RUT", value: "12345678K" },
          {
            icon: Calendar,
            name: "Date Of Birth",
            value: "03/01/1989"
          }
        ],

        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Appointment: {
    path: "/appointment",
    pageTitle: "Experience Our Healthcare Agent",
    agents: [
      {
        id: "3a76fa97-947f-4348-af27-b255beb8a9a1",
        name: "Appointment Booking",
        agentName: "Cathy",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Handle appointment booking"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Datalot: {
    path: "/datalot",
    pageTitle: "Experience Our AI Agent",
    agents: [
      {
        id: "e255ba86-c384-487d-b235-2fcbfde26bd0",
        name: "Datalot FAQ Agent",
        agentName: "Dana",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "Answers Agent FAQs related to Billing & Account Troubleshooting"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  NPR: {
    path: "/NPR",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "1dccc210-991f-46f8-b853-f1075487aad5",
        name: " NPR Donation Agent",
        agentName: "Emily",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "Collects information for Donation",
          "Answers Donation FAQs"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  EmpireToday: {
    path: "/empire-today",
    pageTitle: "Experience our AI agents",
    agents: [
      {
        id: "677db2cf-5477-44eb-af6e-76c50282438e",
        name: "Empire Today FAQ Agent",
        agentName: "Emily",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Answers general, financing & services related FAQs"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  VoiceXDM: {
    path: "/voicex-dm",
    pageTitle: "Experience Our VoiceX-DM Agent",
    agents: [
      {
        id: "83aa61a8-c08f-4f42-a227-59cd3566369f",
        name: "Weight Loss Goal",
        agentName: "Divya",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: English", "Task : Sell Nano Pack"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "83aa61a8-c08f-4f42-a227-59cd3566369f",
          tenant_id: OLD_TENANT_ID,
          workspace_id: OLD_WORKSPACE_ID,
          custom_data: {},
          overide_previous_context: true
        }
      },
      {
        id: "383209ba-2ec2-41d4-bda7-892f637368c7",
        name: "Weight Loss Goal",
        agentName: "Priya",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: English", "Task : Sell Nano Pack"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: "dc9c7205-6eb0-49eb-9045-b9f9aea396ff",
          agent_id: "383209ba-2ec2-41d4-bda7-892f637368c7",
          tenant_id: "67005259-6ca4-464e-828a-f3637e80c1d8",
          workspace_id: "67005259-6ca4-464e-828a-f3637e80c1d8",
          custom_data: {},
          overide_previous_context: true
        }
      }
    ]
  },
  VoiceXVAD: {
    path: "/voicex-vad",
    pageTitle: "Experience Our VoiceVAD Agent",
    agents: [
      {
        id: "461edbde-8149-481b-9d1c-7d25ed462263",
        name: "VoiceVAD",
        agentName: "VAD Agent",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Simple agent running with VAD",
          "For internals demos and testing"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: "https://external-proxy.nurixlabs.tech",
          user_id: OLD_USER_ID,
          agent_id: "461edbde-8149-481b-9d1c-7d25ed462263",
          custom_data: {},
          tenant_id: OLD_TENANT_ID,
          workspace_id: OLD_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  Hdfc: {
    path: "/hdfc",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "7773278f-26e4-4ad6-97ab-c8a7966fb607",
        name: "Ask Your Policy",
        agentName: "Payal",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Clarify details of your policy"],
        voice: "false",
        chat: "true",
        chatHints: [
          {
            triggers: ["aadhar card", "aadhar"],
            hint: "Last Four digit of Aadhar Card: 5478"
          },
          {
            triggers: ["date Of birth", "birth"],
            hint: "Date Of Birth: 03/01/1989"
          }
        ],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },

      {
        id: "ee264bdb-37ea-4403-b25e-0195c8f76129",
        name: "Ask Your Policy",
        agentName: "Payal",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Clarify details of your policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          {
            icon: IdCardIcon,
            name: "Last Four digit of Aadhar Card",
            value: "5478"
          },
          {
            icon: Calendar,
            name: "Date Of Birth",
            value: "03/01/1989"
          }
        ],

        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  HdfcNew: {
    path: "/hdfc-new",
    pageTitle: "Experience Our Voice AI Agents",
    agents: [
      {
        id: "70d652d7-95fb-4ad1-b432-1755994ebd7b",
        name: "HDFC Banking Assistant",
        agentName: "Riya",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Resolves lost card issues",
          "Helps adjust card limits",
          "Provides account statements", "Language : Hinglish"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { name: "Date of Birth", value: "01/02/2000" },
          {
            name: "Account No",
            value: "••• •••••• 1234"
          }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
    ]
  },
  HdfcBankingSupport: {
    path: "/hdfc-banking-support",
    pageTitle: "Experience Our Voice AI Agents",
    agents: [
      {
        id: "3a0b5e40539697108263058dbaff9277",
        name: "HDFC Banking Assistant",
        agentName: "Riya",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Resolves lost card issues",
          "Helps adjust card limits",
          "Provides account statements", "Language : Hinglish"],
        voice: "true",
        chat: "true",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { name: "Date of Birth", value: "01/02/2000" },
          {
            name: "Account No",
            value: "••• •••••• 1234"
          }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "7e76889b-0867-42a0-8bc5-82a31cf011d1",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      },
    ]
  },
  HdfcBanking: {
    path: "/hdfc-banking",
    pageTitle: "Experience Our Voice AI Agents",
    agents: [
      {
        id: "84a23924-b601-466b-966d-e72e44935026",
        name: "HDFC Banking Assistant",
        agentName: "Riya",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Resolves lost card issues",
          "Helps adjust card limits",
          "Provides account statements", "Language : Hinglish"],
        voice: "true",
        chat: "true",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { name: "Date of Birth", value: "01/02/2000" },
          {
            name: "Account No",
            value: "••• •••••• 1234"
          }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
    ]
  },
  CultFit: {
    path: "/cult-chat",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "c62de9df-fa9f-4586-8f7b-003d4e08968b",
        name: "Internal Support Agent",
        agentName: "Rohan",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Schedules technician visits.", "Helps submit new equipment or consumables requests.", "Assists with any facility issue (e.g., AC not cooling)."],
        voice: "false",
        chat: "true",
        chatHints: [
        ],
        try_speaking:["Hi, I’m Anisha, ID 42319 - the treadmill in Studio 2 won’t start.","Can you schedule a technician visit for the cable machine?"],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
    ]
  },
  PolicyWatch: {
    path: "/policywatch",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "f1787884-94f7-4961-baeb-12daf75b9133",
        name: "Screening Agent",
        agentName: "Emily",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Lead Screening", "Answering Queries"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Bravely: {
    path: "/bravely",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "e287a02a-6829-4549-afe3-cb6d15aae8a5",
        name: "Executive Coach",
        agentName: "Maya",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "Personalized Coaching for Workplace Challenges",
          "Leadership & Career Development Guidance",
          "Preparation for Difficult Conversations"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  RealEstateIndia: {
    path: "/realestateindia",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "bd422dd3-37db-4ee1-8397-0fd341267db5",
        name: "Lead Qualification Agent",
        agentName: "Rahul",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Marketing: {
    path: "/marketing",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "a426b2f8-3f7c-4be7-a489-766d853b7334",
        name: "Weight Loss Goal",
        agentName: "Mia",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Sell Nano Pack"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "566a8e8e-9ef7-4c0d-9ee4-f6cf25bfb9ab",
        name: "Lead Qualification Agent",
        agentName: "Barbara",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "e4870029-6d0a-4107-b566-ecf240141151",
        name: "Marketing",
        agentName: "Sam",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Marketing Purpose NEX"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  CharlesTaylor: {
    path: "/charles-taylor",
    pageTitle: "Experience Our Lloyd Agents",
    agents: [
      {
        id: "47f11233-f375-4312-af4c-7689efa8aa15",
        name: "Home Insurance FNOL",
        agentName: "Sarah",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Register home damage claim", "Collect incident details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { icon: User2, name: "Claimant name", value: "Brian Jason Smith" },
          {
            icon: Mail,
            name: "Email",
            value: "brian@charlestaylor.com"
          },
          { icon: PhoneIcon, name: "Phone Number", value: "20 3320 8888" },
          { icon: Bell, name: "OTP", value: "123456" }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "abd810e5-ff39-4749-b96f-48ce77002854",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  StateFarm: {
    path: "/state-farm",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "e1ee9d34-ee9f-43d8-a5cd-5a03fae61571",
        name: "Customer Support Agent",
        agentName: "Jake",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["FAQs Agent"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  GetJubilee: {
    path: "/getjubilee",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "9b8b6e6a-ba8d-42f1-b2f1-23be56eca4d0",
        name: "Customer Support Agent",
        agentName: "Sarah",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["FAQs Agent"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  HealthInsuranceSalesDutch: {
    path: "/healthinsurancesales-dutch",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "c662b2d8-de97-4e90-ad70-348bdd19fa92",
        name: "Health Insurance Sales Agent",
        agentName: "Abel",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Assess customer needs", "Suggest best suited policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Amica: {
    path: "/amica",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "991b66e3-b11e-4f72-b9d0-cec17254d201",
        name: "Customer Support Agent",
        agentName: "Sarah",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["FAQs Agent"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  PaisaBazaar: {
    path: "/paisabazaar",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "80b84b6d-73df-4643-9f88-7ccb12e528c1",
        name: "EMI Reminder Agent",
        agentName: "Raj",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Overdue Payment Alerts", "Language: Hinglish"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          {
            name: "Phone Number",
            value: "XXXX-XXXX-3456",
            icon: Phone
          },
          {
            name: "Date of Birth",
            value: "2nd January, 1998",
            icon: Calendar
          }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "00cd5df2-89f7-423b-9f59-fb26350c1e70",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      },
      {
        id: "52384aa5-0a2c-4d98-83d7-d6fd63ebd235",
        name: "EMI Reminder Agent",
        agentName: "Raj",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Overdue Payment Alerts", "Language: Hindi"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          {
            name: "Phone Number",
            value: "XXXX-XXXX-3456",
            icon: Phone
          },
          {
            name: "Date of Birth",
            value: "2nd January, 1998",
            icon: Calendar
          }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "ab3dd834-6220-4e52-b15d-b5e33f5d13bb",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  Abcl: {
    path: "/abcl-voicex-tts-options",
    pageTitle: "Experience Our ABCL Agents",
    agents: [
      {
        id: "47f11233-f375-4312-af4c-7689efa8aa15",
        name: "ABCL-elevenlabs",
        agentName: "Priya",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["personal loan enquiry", "checking eligibility"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "c5613846-d03a-44f6-9044-0eb00eb19fd4",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      },
      {
        id: "47f11233-f375-4312-af4c-7689efa8aa15",
        name: "ABCL-azure",
        agentName: "Arjun",
        icon: memoji1,
        chatIcon: memoji5Chat,
        featureList: ["personal loan enquiry", "checking eligibility"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "8260fd63-2920-4a98-8bd0-a35035d2c28c",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      },
      {
        id: "47f11233-f375-4312-af4c-7689efa8aa15",
        name: "ABCL-google",
        agentName: "Arjun",
        icon: memoji1,
        chatIcon: memoji5Chat,
        featureList: ["personal loan enquiry", "checking eligibility"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "9fab9061-6be9-44dc-ac49-b7f47442809d",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      },
      {
        id: "47f11233-f375-4312-af4c-7689efa8aa15",
        name: "ABCL-openai",
        agentName: "Arjun",
        icon: memoji1,
        chatIcon: memoji5Chat,
        featureList: ["personal loan enquiry", "checking eligibility"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "54a4cd8a-aef8-42e7-b6ea-a17c6897c4b8",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  LibertyMutual: {
    path: "/LibertyMutual",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "ff74628b-5dd5-4b4a-9749-1e8e3ffa9bbe",
        name: "Customer Support Agent",
        agentName: "Doug",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["FAQs Agent"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  SmoothieKing: {
    path: "/smoothieking",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "50d63ff6-85a1-4dd0-9f39-29b6ecf664ba",
        name: "Customer Service Representative",
        agentName: "Myra",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["Taking orders", "Scheduling Pickup"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  // Sompo: {
  //   path: "/sompo",
  //   pageTitle: "Experience Our AI Agents",
  //   agents: [
  //     {
  //       id: "7459bc15-0f08-483d-92e3-e9330d7851f1",
  //       name: "Home Insurance FNOL",
  //       agentName: "Mizuki",
  //       icon: memoji2,
  //       chatIcon: memoji2Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     },
  //     {
  //       id: "6aa522a8-4ecd-4e40-96c2-b588458bef7a",
  //       name: "Home Insurance FNOL",
  //       agentName: "Mizuho",
  //       icon: memoji2,
  //       chatIcon: memoji2Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     },
  //     {
  //       id: "a0a65e13-854e-441b-9544-53c706de9ec8",
  //       name: "Home Insurance FNOL",
  //       agentName: "Kaaho",
  //       icon: memoji2,
  //       chatIcon: memoji2Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     },
  //     {
  //       id: "912981a0-f6c0-45cc-a053-f8acc2631859",
  //       name: "Home Insurance FNOL",
  //       agentName: "Chanju",
  //       icon: memoji2,
  //       chatIcon: memoji2Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     }
  //   ]
  // },
  Hinglish: {
    path: "/hinglish",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "a5717a89-e78c-458d-8cdf-d094e84cd496",
        name: "Order Tracking and Return",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          " Order tracking",
          "Return and exchange status",
          "Language: Hinglish"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [
          { name: "Bluetooth Speaker", value: "ID: 1234" },
          { name: "Polo Tshirt", value: "ID: 1235" },
          { name: "Puma Sneakers", value: "ID: 1236" },
          { name: "Linen Shirt", value: "ID: 1239" },
          { name: "Nike Track Pant", value: "ID: 1237" }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "4bf07fb7-aa14-4c43-b9e4-f77f42eea12d",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  philipsCohen: {
    path: "/philips-cohen",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "04d044da-542c-45e1-8cf8-8ad93773a7e3",
        name: "Collections Agent",
        agentName: "Maria",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["Remind users to pay overdue"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { name: "Name of User", value: "Mr Robin Smith" },
          { name: "Social security code", value: "3456" },
          { name: "Date of Birth", value: "2nd Jan 1998" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Coterie: {
    path: "/coterie",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "17a638dc-a51f-43d6-8946-cb43d7699ced",
        name: "Assist Agent",
        agentName: "Coterie",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "Assist user in finding best company",
          "Getting pre quote requirements",
          "Getting outreach script",
          "Coverage Recommender"
        ],
        voice: "false",
        chat: "true",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  BankingPhilippines: {
    path: "/banking-Philippines",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "3036147c-1f87-4918-8a1a-ff629b9c7f0b",
        name: "Collections Agent",
        agentName: "Mark",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Remind users to pay overdue"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { name: "Name of User", value: "Mr Francis" },
          { name: "Date of Birth", value: "2nd Jan 1998" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Encore: {
    path: "/encore",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "78f5a0b5-ad84-42ba-8c05-458bfaf1011e",
        name: "Collections Agent",
        agentName: "Maria",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["Remind users to pay overdue"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { icon: User, name: "Name of User", value: "Mr Robin Smith" },
          { icon: CreditCard, name: "Social security code", value: "3456" },
          { icon: Calendar, name: "Date of Birth", value: "2nd Jan 1998" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Event: {
    path: "/event",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "f633fce0-9044-4f2d-86d9-2ea34c79db47",
        name: "Home Insurance Sales",
        agentName: "Nura",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["Assess customer needs", "Suggest best suited policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  FNOL: {
    path: "/FNOL",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "69771e60-33d8-4624-bb79-e9853c35a139",
        name: "Home Insurance FNOL",
        agentName: "Sarah",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["Register home damage claim", "Collect incident details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { name: "Claimant name", value: "John Doe" },
          { name: "Phone Number ", value: "555-123-4567" },
          { name: "Policy Number", value: "NRX-1234" },
          { name: "OTP", value: "123456" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  BfsiMultilingual: {
    path: "/bfsi-multilingual",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "2c37e5c4-2efb-43a5-bebd-a366ff29f859",
        name: "Banking Customer Support",
        agentName: "Pranav",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Bank account inquiry",
          "Lost credit card reporting",
          "Card limit modification"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [
          { name: "Date of Birth", value: "1st February 2000" },
          { name: "Account Number", value: "••• •••••• 1234" }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "86af47c8-0ecf-44e8-9c73-ed0f30c08516",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  // SompoJapan: {
  //   path: "/sompo-japan",
  //   pageTitle: "Experience Our AI Agents",
  //   agents: [
  //     {
  //       id: "710d77f2-8dba-4fd9-b704-d2089370b4b0",
  //       name: "Home Insurance FNOL",
  //       agentName: "Fuzi",
  //       icon: memoji1,
  //       chatIcon: memoji1Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     },
  //     {
  //       id: "850b132f-3af9-4069-883a-e3db42f20180",
  //       name: "Home Insurance FNOL",
  //       agentName: "Kenji",
  //       icon: memoji1,
  //       chatIcon: memoji1Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     },
  //     {
  //       id: "cccb290e-488e-4ef5-afc6-a2f44d3c9ac3",
  //       name: "Home Insurance FNOL",
  //       agentName: "Akira",
  //       icon: memoji1,
  //       chatIcon: memoji1Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     },
  //     {
  //       id: "0090fa33-897d-4d50-a50e-eab128f423b8",
  //       name: "Home Insurance FNOL",
  //       agentName: "Haruto",
  //       icon: memoji1,
  //       chatIcon: memoji1Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     }
  //   ]
  // },
  Xanadu: {
    path: "/xanadu",
    pageTitle: "Experience Our AI Agents",
    agents: [
      // {
      //   id: "0ed83b9d-1a54-4e47-a397-b22c9936f672",
      //   name: "Real Estate Sales",
      //   agentName: "Raj",
      //   icon: memoji1,
      //   chatIcon: memoji1Chat,
      //   featureList: [
      //     "Assess customer needs",
      //     "Suggest best suited home",
      //     "Booking Appointment for visit",
      //     "Language: Hindi"
      //   ],
      //   voice: "true",
      //   chat: "false",
      //   chatHints: [],
      //   callHintsTable: [],
      //   callHints: [],
      //   voiceInputs: [],
      //   voiceProvider: "voicex",
      //   voiceConfig: {
      //     baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
      //     user_id: DEFAULT_USER_ID,
      //     agent_id: "24be1c2c-fb83-458a-a7e4-e0bd903fb800",
      //     tenant_id: DEFAULT_TENANT_ID,
      //     workspace_id: DEFAULT_WORKSPACE_ID,
      //     overide_previous_context: true
      //   }
      // },
      {
        id: "00e2b951-a953-456a-b3c6-d0e17750d47e",
        name: "Real Estate Sales",
        agentName: "Raj",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Assess customer needs",
          "Suggest best suited home",
          "Booking Appointment for visit",
          "Language: Hinglish"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "e1b12a76-ac4a-4f1c-988f-4f9035416241",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      },
      // {
      //   id: "29bcc556-6ead-443c-a919-3f2313ad4cc1",
      //   name: "Real Estate Sales",
      //   agentName: "Raj",
      //   icon: memoji1,
      //   chatIcon: memoji1Chat,
      //   featureList: [
      //     "Assess customer needs",
      //     "Suggest best suited home",
      //     "Booking Appointment for visit",
      //     "Language: English"
      //   ],
      //   voice: "true",
      //   chat: "false",
      //   chatHints: [],
      //   callHintsTable: [],
      //   callHints: [],
      //   voiceInputs: [],
      //   voiceProvider: "voicex",
      //   voiceConfig: {
      //     baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
      //     user_id: DEFAULT_USER_ID,
      //     agent_id: "7b97b11d-90ba-4b43-8581-91354b78e098",
      //     tenant_id: DEFAULT_TENANT_ID,
      //     workspace_id: DEFAULT_WORKSPACE_ID,
      //     overide_previous_context: true
      //   }
      // },
      {
        id: "5d46d0d2-060c-4b2f-8958-2db463aab2a0",
        name: "Real Estate Sales",
        agentName: "Payal",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: [
          "Assess customer needs",
          "Suggest best suited home",
          "Booking Appointment for visit",
          "Language: Marathi"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "25f4d184-37b4-4af3-b494-3430dd76f15c",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  HealthFirst: {
    path: "/healthfirst",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "a5b5d096-9ea3-4df3-8c79-4bc51e1cf890",
        name: "HealthFirst Customer Support ",
        agentName: "Susan",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["FAQs Agent"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "7e05a79b-f75c-4c61-b3c7-0f9a9195ce4c",
        name: "HealthFirst Insurance Sales",
        agentName: "Merissa",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Assess customer needs", "Suggest best suited policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Prudential: {
    path: "/prudential",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "a17fd27a-cad7-487d-8acf-70cd974349d3",
        name: "Customer Support Agent",
        agentName: "Susan",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["FAQs Agent"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  // SompoInsurance: {
  //   path: "/sompo-insurance",
  //   pageTitle: "Experience Our AI Agents",
  //   agents: [
  //     {
  //       id: "850b132f-3af9-4069-883a-e3db42f20180",
  //       name: "Home Insurance FNOL",
  //       agentName: "Kenji",
  //       icon: memoji1,
  //       chatIcon: memoji1Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     },
  //     {
  //       id: "0090fa33-897d-4d50-a50e-eab128f423b8",
  //       name: "Home Insurance FNOL",
  //       agentName: "Haruto",
  //       icon: memoji1,
  //       chatIcon: memoji1Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     },
  //     {
  //       id: "69497b3a-9895-4451-97dc-9e6611c84b9d",
  //       name: "Home Insurance FNOL",
  //       agentName: "Orus",
  //       icon: memoji1,
  //       chatIcon: memoji1Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "voicex",
  //       voiceConfig: {
  //         baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
  //         user_id: DEFAULT_USER_ID,
  //         agent_id: "6e9fa909-d981-480b-91cc-87c57b5a3baa",
  //         tenant_id: DEFAULT_TENANT_ID,
  //         workspace_id: DEFAULT_WORKSPACE_ID,
  //         overide_previous_context: true
  //       }
  //     }
  //   ]
  // },
  HealthInsurance: {
    path: "/health-insurance",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "839d1826-1ab1-47dd-9c95-e8469d822cab",
        name: "Health Insurance Sales",
        agentName: "Aayush",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Assess customer needs",
          "Suggest best suited policy",
          "Language: Hinglish"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "631422e0-3321-4805-b26a-cbf2db5e0aa8",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  // SompoFinal: {
  //   path: "/sompo-final",
  //   pageTitle: "Experience Our AI Agents",
  //   agents: [
  //     {
  //       id: "850b132f-3af9-4069-883a-e3db42f20180",
  //       name: "Home Insurance FNOL",
  //       agentName: "Kenji",
  //       icon: memoji1,
  //       chatIcon: memoji1Chat,
  //       featureList: ["Register home damage claim", "Collect incident details"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         { icon: User2, name: "Date of Birth", value: "03/01/1989" },
  //         { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
  //         { icon: Bell, name: "OTP", value: "123456" }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "retell",
  //       voiceConfig: {}
  //     }
  //   ]
  // },
  Japanese: {
    path: "/japanese",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "f3aed753-77cf-42bc-bd0d-df5a5281eb24",
        name: "Home Insurance FNOL",
        agentName: "Kenji",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Register home damage claim", "Collect incident details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { icon: User2, name: "Date of Birth", value: "03/01/1989" },
          { icon: PhoneIcon, name: "Phone Number", value: "90 1234 5678" },
          { icon: Bell, name: "OTP", value: "123456" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  SignalMutual: {
    path: "/signalmutual",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "14a04e70-5b60-4b0a-8a84-535e7f99260b",
        name: "Worker's Compensation FNOL",
        agentName: "Sarah",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "Report a workplace injury claim",
          "Collect incident details"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { name: "Claimant Name", value: "John Doe" },
          { name: "Phone Number", value: "555-123-4567" },
          { name: "Policy Number", value: "NRX-1234" },
          { name: "OTP", value: "123456" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },

  USAA: {
    path: "/usaa",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "8556da7b-b1fc-44d3-9aa2-d9612e35b293",
        name: "Lead Qualification",
        agentName: "Sarah",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Capture Caller Intent", "Check Membership Eligibility"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },

  AWSPolly: {
    path: "/aws-polly",
    pageTitle: "Experience AWS Polly",
    agents: [
      {
        id: "023b6bf5-7268-4000-93a0-ed6d2b3bc02c",
        name: "AWS Polly",
        agentName: "Joanna",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["AWS Polly", "Language: English"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "3f1f0d63-3a90-4710-bea4-9f4755a50630",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  SalaryFinance: {
    path: "/salaryfinance",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "86625241-1ef5-4f4a-b8b9-f1694344aca6",
        name: "Customer Support Agent",
        agentName: "Luis Moore",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["FAQs Agent"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          {
            icon: Dot,
            name: "DOB : 3rd January 1998"
          },
          { name: "Try these questions:-" },
          {
            icon: Dot,
            name: "Can you prove my employer authorised you to deduct this from my salary?"
          },
          {
            icon: Dot,
            name: "What statutory authority lets Salary Finance access my credit file without consent?"
          }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "f5347b55-6526-406f-831c-2a05827105c3",
        name: "Collections Agent",
        agentName: "Maria",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Remind users to pay overdue"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          {
            icon: Dot,
            name: "DOB : 3rd January 1998"
          },
          { name: "Try these questions :-" },
          {
            icon: Dot,
            name: "If I choose a three-month plan, how is the zero-interest feature guaranteed?"
          },
          {
            icon: Dot,
            name: "Is it possible to change the debit date so it lines up with my payday?"
          }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "00b9a461-7b3a-4f7a-825a-ee4b10c7e135",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  Fitness: {
    path: "/fitness",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "b5932428-ce49-401f-91df-c3d21e673f64",
        name: "Customer Support Agent",
        agentName: "Lina",
        icon: memoji3,
        chatIcon: memoji3Chat,
        featureList: ["FAQs Agent"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "0831261c-c9cc-49a4-bc1e-37796b964dda",
        name: "Lead Qualification agent",
        agentName: "Alex",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  EzySchooling: {
    path: "/ezyschooling",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "d80cf759-e148-401e-88a0-7efce90db646",
        name: "Lead Qualification Agent",
        agentName: "Payal",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "d71ea74c-df35-46ad-b94a-4992cc32ea08",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  ChickFila: {
    path: "/chick-fil-a",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "0cb1faac-eeec-4a1d-a998-60b28b1263bc",
        name: "Customer Service Representative",
        agentName: "Myra",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Taking orders", "Scheduling Pickup / Delivery"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  NurixTest: {
    path: "/nurix-test",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "3f7b2901-3333-4c3b-a400-dd38f6119bef",
        name: "Website agent",
        agentName: "Nura",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  CityFacilities: {
    path: "/city-facilities",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "784065ea-73c7-4db6-9654-a84bd26c3570",
        name: "Pre-Screening Agent",
        agentName: "Emily",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [
          "Provides Job Details",
          "Efficiently Schedules Interviews",
          "Enhances Applicant Engagement"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  QuoteWizard: {
    path: "/quoteWizard",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "2709372d-f154-4fd5-a66f-13f86cb11818",
        name: "Screening Agent",
        agentName: "Micaela",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Lead Screening", "Answering Queries"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  InsuranceHinglish: {
    path: "/insurancehinglish",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "74cd85e3-3735-4e84-a01a-ee51713214d4",
        name: "Sales and Renewal for Two-wheeler",
        agentName: "Robin",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  InsuranceHindi: {
    path: "/insurancehindi",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "6bbf47ad-f125-49dc-a81d-857ffe667251",
        name: "Sales and Renewal for Two-wheeler",
        agentName: "Robin",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  InsuranceHinglishAgentx: {
    path: "/insurance-hinglish",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "61e89f44-04d6-4b8b-a340-aa7028a5aed8",
        name: "Sales and Renewal for Two-wheeler",
        agentName: "Robin",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "3704a72f-00e5-42d0-a78b-e885720048ec",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  Realtor: {
    path: "/realtor",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "8eb4f684-69f7-4f0a-a610-57e6342767b1",
        name: "Real Estate Support Agent",
        agentName: "Sarah",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["FAQ agent"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "fa441586-b41e-4756-abd5-f4435a8f126d",
        name: "Lead Qualification Agent",
        agentName: "Barbara",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Insurica: {
    path: "/insurica",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "1ed7b4d1-fb32-4bd2-944a-84f759c27a39",
        name: "Auto Insurnace Renewal",
        agentName: "Emily",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Policy Updates Collection", "Renewal Reminders"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  MutualOfOhama: {
    path: "/mutual-of-ohama",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "99dc8ecf-f311-4fc1-a7f0-e72afe14fa56",
        name: "Customer Support agent",
        agentName: "Marissa",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Answer FAQs"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  AmicaInsurance: {
    path: "/amica-insurance",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "1d7effe3-116b-4989-9739-3574cc26526d",
        name: "Auto Insurance Renewal",
        agentName: "Emily",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Answering policy queries", "Upgrading policies"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "15305025-a71f-4cac-a314-1e5b2d68a492",
        name: "Home Insurance FNOL",
        agentName: "Sarah",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Register home damage claim", "Collect incident details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  XanaduHinglish: {
    path: "/xanadu-hinglish",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "d6f9e2db-24ba-4226-87c4-51469ae3063b",
        name: "Real Estate Sales",
        agentName: "Payal",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [
          "Assess customer needs",
          "Suggest best suited home",
          "Booking Appointment for visit",
          "Language: Hinglish"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "cbd7a700-46a6-4676-97b1-f806d66a45bb",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },

  // Tata1mg: {
  //   path: "/tata-1mg-obesity",
  //   pageTitle: "Experience our AI Agents",
  //   agents: [
  //     {
  //       id: "6f7ee6f8-aad5-41d6-9322-803e84649e7d",
  //       name: "Obesity Counselling agent",
  //       agentName: "Payal",
  //       icon: memoji5,
  //       chatIcon: memoji5Chat,
  //       featureList: ["FAQs", "Customer support", "Language:Hinglish"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [
  //         {
  //           icon: Dot,
  //           name: "Tell me about obesity related support?."
  //         },
  //         {
  //           icon: Dot,
  //           name: "What lab tests help manage my weight better?"
  //         }
  //       ],
  //       voiceInputs: [],
  //       voiceProvider: "voicex",
  //       voiceConfig: {
  //         baseUrl: VOICEX_URL_CONSTANTS["voicex-stage"],
  //         user_id: STAGE_USER_ID,
  //         agent_id: "ff3a1b1d-549d-45b5-b197-ce698ddc2559",
  //         tenant_id: STAGE_TENANT_ID,
  //         workspace_id: STAGE_WORKSPACE_ID,
  //         overide_previous_context: true
  //       }
  //     }
  //   ]
  // },

  StudentEdge: {
    path: "/studentedge",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "700ca37c-c011-423d-acfb-d3bd5bbcf3c1",
        name: "Customer Support Agent",
        agentName: "Payal",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["FAQs"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "700ca37c-c011-423d-acfb-d3bd5bbcf3c1", // "700ca37c-c011-423d-acfb-d3bd5bbcf3c1",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  ABCLDemo: {
    path: "/abcl-demo",
    pageTitle: "Experience Our ABCL Agent",
    agents: [
      {
        id: "cd655c99-a1f9-40ca-b8fa-da0558dc56b0",
        name: "Loan Qualifier",
        agentName: "Asha",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Loan qualification expert"],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          agent_id: "cd655c99-a1f9-40ca-b8fa-da0558dc56b0",
          overide_previous_context: true
        },
        chatHints: [],
        callHints: [],
        callHintsTable: []
      }
    ]
  },
  Usha: {
    path: "/usha",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "315ffd79-d74c-4e7e-a745-bc87b4873dd0",
        name: "Customer Support Agent",
        agentName: "Priya",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Troubleshooting Assistance", "Service Request Booking"],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          agent_id: "315ffd79-d74c-4e7e-a745-bc87b4873dd0",
          overide_previous_context: true
        },
        chatHints: [],
        callHints: [],
        callHintsTable: []
      }
    ]
  },
  Marriott: {
    path: "/marriott",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "ad39fe34-cc76-4d29-8ce1-d335d32fdc3a",
        name: "Room Booking",
        agentName: "Victoria",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: [
          "Handle room booking",
          "Answer property FAQs",
          "Travel and Spa booking"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        chatHints: [],
        callHints: [
          {
            icon: Dot,
            name: "Name : John Atkins"
          },
          {
            icon: Dot,
            name: "Email: john@gmail.com"
          },
          {
            icon: Dot,
            name: "Address: 501 Washington Street Indianapolis, United States"
          }
        ],
        callHintsTable: []
      }
    ]
  },
  Noise: {
    path: "/noise",
    pageTitle: "Experience Our Retail Agents",
    agents: [
      {
        id: "a7086330-ea45-4376-bdc8-47f6d84c5dde",
        name: "Order Tracking & Return",
        agentName: "Raj",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Order tracking",
          "Return and exchange status",
          "Language: Hinglish"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { name: "Sound Master Speaker", value: "ID: 1234" },
          { name: "Pop Buds", value: "ID: 1235" },
          { name: "Airwave Max 3- headphones", value: "ID: 1236" },
          { name: "Tune active pro", value: "ID: 1239" },
          { name: "ColorFit Macro", value: "ID: 1237" },
          { name: "ColorFit Mighty:", value: "ID: 1238" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          agent_id: "a88635a5-ffcd-4b9a-a10d-7924e90e315f",
          overide_previous_context: true
        }
      }
    ]
  },
  IndianLanguages: {
    path: "/indian-languages",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "00e2b951-a953-456a-b3c6-d0e17750d47e",
        name: "Real Estate Sales",
        agentName: "Raj",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Assess customer needs",
          "Suggest best suited home",
          "Booking Appointment for visit",
          "Language: Hinglish"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "09c05bd7-7a68-46e8-92ad-4992d925a768",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      },
      {
        id: "5d46d0d2-060c-4b2f-8958-2db463aab2a0",
        name: "Real Estate Sales",
        agentName: "Payal",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: [
          "Assess customer needs",
          "Suggest best suited home",
          "Booking Appointment for visit",
          "Language: Marathi"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "cde86345-00f0-4f52-aed6-dbbdf45c5909",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  AppFolio: {
    path: "/Appfolio",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "8b69ca76-61fe-4c57-9c7a-c1887a6371cf",
        name: "Lead Qualification",
        agentName: "Ava",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: [
          "Qualify leads and verify details",
          "Schedule property tours"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        chatHints: [],
        callHints: [
          {
            icon: Dot,
            name: "Name : Sarah"
          },
          {
            icon: Dot,
            name: "Email: sarah@gmail.com"
          }
        ],
        callHintsTable: []
      }
    ]
  },
  PaisaBazaar2: {
    path: "/paisabazaar-2",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "400613d1-0807-4ee2-b57f-a65a7cb16718",
        name: "EMI Reminder Agent",
        agentName: "Raj",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Overdue Payment Alerts", "Language: Hinglish"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          {
            name: "Name:Ram",
            icon: Dot
          }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "d1f00f20-17b2-4990-85d2-e119ccbd1d46",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  Velocity: {
    path: "/velocity",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "c713658e-4a3a-403a-b140-5750989a1e4f",
        name: "Customer Support",
        agentName: "Alex",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Language: English"],
        voice: "false",
        chat: "true",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Churchill: {
    path: "/churchill",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "843bcf04-a9c9-4718-be5f-df62d05389e6",
        name: "Lead Qualification Agent",
        agentName: "Nancy",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        chatHints: [],
        callHints: [],
        callHintsTable: []
      }
    ]
  },
  Expedia: {
    path: "/expedia",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "0ab93b94-b9d9-43ba-8ba3-89e1c7354fc4",
        name: "Auto Insurance Renewal",
        agentName: "Ethan",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Sales Qualification",
          "Policy Updates Collection",
          "Renewal Reminders"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "28d274aa-5cbb-4ba7-b07d-80da5dae877c",
        name: "Home sales qualification",
        agentName: "Marissa",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  MandelFamily: {
    path: "/MandelFamily",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "dee1db43-8667-43bc-85e4-dbb10a60b8a8",
        name: "Customer Support Agent",
        agentName: "Susan",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: [
          "Explains common wealth & insurance questions",
          "Answers Sky Gem FAQs"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        chatHints: [],
        callHints: [],
        callHintsTable: []
      }
    ]
  },
  // GSG: {
  //   path: "/GSG",
  //   pageTitle: "Experience our AI Agents",
  //   agents: [
  //     {
  //       id: "400613d1-0807-4ee2-b57f-a65a7cb16718",
  //       name: "Customer Support for Global Schools Group",
  //       agentName: "GSG",
  //       icon: memoji1,
  //       chatIcon: memoji1Chat,
  //       featureList: ["Language: English"],
  //       voice: "true",
  //       chat: "false",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: [],
  //       voiceInputs: [],
  //       voiceProvider: "voicex",
  //       voiceConfig: {
  //         baseUrl: VOICEX_URL_CONSTANTS["voicex-stage"],
  //         user_id: DEFAULT_USER_ID,
  //         agent_id: "400613d1-0807-4ee2-b57f-a65a7cb16718",
  //         tenant_id: DEFAULT_TENANT_ID,
  //         workspace_id: DEFAULT_WORKSPACE_ID,
  //         overide_previous_context: true
  //       }
  //     }
  //   ]
  // },
  Hiscox: {
    path: "/hiscox",
    pageTitle: "Experience Our Banking Agents",
    agents: [
      // {
      //   id: "19e7550f-70d8-4108-91f5-204ffed3ac64",
      //   name: "Home Insurance FNOL",
      //   agentName: "Sarah",
      //   icon: memoji5,
      //   chatIcon: memoji5Chat,
      //   featureList: ["Register home damage claim", "Collect incident details"],
      //   voice: "true",
      //   chat: "false",
      //   chatHints: [],
      //   callHints: [
      //     { name: "Claimant name", value: "Brian Jason Smith" },
      //     { name: "Email", value: "Brian@gmail.com" },
      //     { name: "Phone Number", value: "20 3320 8888" },
      //     { name: "Code", value: "123456" }
      //   ],
      //   callHintsTable: [],
      //   voiceInputs: [],
      //   voiceProvider: "retell",
      //   voiceConfig: {}
      // },
      {
        id: "3ff64875-40d3-4051-afaa-d9b796de2277",
        name: "Home Insurance FNOL",
        agentName: "Jane",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Register home damage claim", "Collect incident details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { name: "Claimant name", value: "Rupert Montague" },
          { name: "Email", value: "Rupert.Montague@gmail.com" },
          { name: "Phone Number", value: "20 3320 8888" },
          { name: "Code", value: "123456" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
      // {
      //   id: "6f3a6726-9ff4-4bf3-bf02-d0437318d864",
      //   name: "Home Insurance FNOL",
      //   agentName: "Elizabeth",
      //   icon: memoji3,
      //   chatIcon: memoji3Chat,
      //   featureList: ["Register home damage claim", "Collect incident details"],
      //   voice: "true",
      //   chat: "false",
      //   chatHints: [],
      //   callHints: [
      //     { name: "Claimant name", value: "Brian Jason Smith" },
      //     { name: "Email", value: "Brian@gmail.com" },
      //     { name: "Phone Number", value: "20 3320 8888" },
      //     { name: "Code", value: "123456" }
      //   ],
      //   callHintsTable: [],
      //   voiceInputs: [],
      //   voiceProvider: "retell",
      //   voiceConfig: {}
      // }
    ]
  },
  Cinch: {
    path: "/cinch",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "6f4cb6e1-e238-48a9-aadd-3cec220c8119",
        name: "Customer Support Agent",
        agentName: "Sarah",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["FAQ agent"],
        voice: "true",
        chat: "false",
        demo: "false",
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        chatHints: [],
        callHints: [],
        callHintsTable: []
      }
    ]
  },
  GlobalAssure: {
    path: "/global-assure",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "a2682f62-0186-4322-a5ec-0a3e95f9fc1f",
        name: "RSA Agent",
        agentName: "Raj",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Register RSA request",
          "Verify customer identity",
          "Capture incident details and initiate assistance"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          {
            icon: Dot,
            name: "Name: Ajay Kumar"
          },
          {
            icon: Dot,
            name: "Vehicle Number: GJ01 KN 1234"
          },
          {
            icon: Dot,
            name: "Car Make and Model: Hyundai Creta"
          },
          {
            icon: Dot,
            name: "Phone number: 9547876789"
          },
          {
            icon: Dot,
            name: "Policy Number: 1234 7890 4567 3452"
          }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "a2682f62-0186-4322-a5ec-0a3e95f9fc1f",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  Velociti: {
    path: "/velociti",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "0ab93b94-b9d9-43ba-8ba3-89e1c7354fc4",
        name: "Auto Insurance Renewal",
        agentName: "Ethan",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Sales Qualification",
          "Policy Updates Collection",
          "Renewal Reminders"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "28d274aa-5cbb-4ba7-b07d-80da5dae877c",
        name: "Home sales qualification",
        agentName: "Marissa",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Hagerty: {
    path: "/hagerty",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "d4a6468d-136a-4698-9111-0deaf58451c5",
        name: "Auto Insurance Renewal",
        agentName: "Ethan",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Sales Qualification",
          "Policy Updates Collection",
          "Renewal Reminders"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "5f7065bb-5b17-4fde-8cff-e82fd1adec11",
        name: "Auto Insurance FNOL",
        agentName: "Hannah",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Register Auto damage claim", "Collect incident details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          {
            icon: Dot,
            name: "Claimant name: Robert Smith"
          },
          {
            icon: Dot,
            name: "Phone Number: 231 555 1234"
          },
          {
            icon: Dot,
            name: "Email: Robert.smith@gmail.com"
          },
          {
            icon: Dot,
            name: "OTP: 123456"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  RocketLearning: {
    path: "/rocket-learning",
    pageTitle: "Experience our AI Agents",
    agents: [
      {
        id: "de27424f-9aa9-4ea7-8324-39be86b78d7f",
        name: "Mission Buniyaad agent",
        agentName: "Aditi",
        icon: memoji3,
        chatIcon: memoji3Chat,
        featureList: [
          "Engage parents on WhatsApp",
          "Motivate regular learning activities"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "de27424f-9aa9-4ea7-8324-39be86b78d7f",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  ColliersInternational: {
    path: "/colliers-international",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "fffebdc8-3c87-416c-b3fd-6d4d20385585",
        name: "Customer Support",
        agentName: "Claire",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Language: English"],
        voice: "false",
        chat: "true",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  CandWAppliance: {
    path: "/c&w-appliance",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "3dd22ae1-f322-4bbc-ae67-4b23bf3017b2",
        name: "Customer Support",
        agentName: "Charlotte",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Appliance, technician, payment FAQs",
          "Language: English"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          {
            icon: Dot,
            name: "What payments method to be accept?"
          },
          {
            icon: Dot,
            name: "What time will the C&W Technician arrive on my selected day?"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Tata1MG: {
    path: "/tata-1mg",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "2fb45730-e2f9-4dd6-85e7-295e07cecf3a",
        name: "FAQ agent",
        agentName: "Robin",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Languages: English, Hinglish, Vernacular"],
        voice: "false",
        chat: "true",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "12e42348-64b1-463e-8961-5afd32d9a1b2",
        name: "Payments support Agent",
        agentName: "Payal",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Payment FAQs", "Language: Hinglish"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          {
            icon: Dot,
            name: "How can I make a payment for my test? "
          },
          {
            icon: Dot,
            name: "I paid twice or was overcharged. How can I get a refund? "
          }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-stage"],
          user_id: DEFAULT_USER_ID,
          agent_id: "6185f3fb-27c7-49e9-8355-800148f5efd8",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        }
      },
      {
        id: "6f7ee6f8-aad5-41d6-9322-803e84649e7d",
        name: "Obesity Counselling agent",
        agentName: "Payal",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["FAQs", "Customer support", "Language:Hinglish"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          {
            icon: Dot,
            name: "Tell me about obesity related support?."
          },
          {
            icon: Dot,
            name: "What lab tests help manage my weight better?"
          }
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-stage"],
          user_id: STAGE_USER_ID,
          agent_id: "ff3a1b1d-549d-45b5-b197-ce698ddc2559",
          tenant_id: STAGE_TENANT_ID,
          workspace_id: STAGE_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  Kohler: {
    path: "/kohler",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "324dad60-2a65-48fd-aca7-40e01d617206",
        name: "Lead Qualification Agent",
        agentName: "Sarah",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  liquide: {
    path: "/liquide",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "f323b639-b33f-46f7-acc8-e3c134b4e491",
        name: "Customer Support Agent",
        agentName: "Riya",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "All liquide feature and subscription related FAQs"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: US_USER_ID,
          agent_id: "f323b639-b33f-46f7-acc8-e3c134b4e491", // 0db740fb-ab0d-42f3-bb06-58282e80fb32
          tenant_id: US_TENANT_ID,
          workspace_id: US_WORKSPACE_ID,
          overide_previous_context: true
        }
      }
    ]
  },
  Bambinos: {
    path: "/bambinos",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Bambinos",
    agents: [
      {
        id: "d5a14f1c-8128-4f99-9e6f-79641a2a7e53",
        name: "Customer Support Agent",
        description:
          "Helps people with their queries about Bambinos.Live",
        subDescription:
          "Helps people with their queries about Bambinos.Live",
        agentName: "Mira",
        icon: "https://retell-utils-public.s3.us-west-2.amazonaws.com/nina.png",
        chatIcon:
          "https://retell-utils-public.s3.us-west-2.amazonaws.com/nina.png",
        featureList: ["All information about the courses offered by Bambinos and general FAQs."],
        voice: "true",
        chat: "false",
        callTitle: "Customer Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "d5a14f1c-8128-4f99-9e6f-79641a2a7e53",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: []
      },
    ]
  },
  BambinosUcTest: {
    path: "/bambinos-uc-test",
    pageTitle: "Experience Our Demo AI Agents",
    agents: [
      {
        id: "c362f5e6-e982-47ab-bfbb-c31ca4bf152c",
        name: "UC2",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Demo Fallback Recovery"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "c362f5e6-e982-47ab-bfbb-c31ca4bf152c",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      },
      {
        id: "961b8f32-1a9d-4b24-be1a-dcc9b357d417",
        name: "UC1",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Demo Funnel Optimization"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "961b8f32-1a9d-4b24-be1a-dcc9b357d417",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      }
    ]
  },
  BambinosUcTest2: {
    path: "/bambinos-uc-test2",
    pageTitle: "Experience Our Demo AI Agents",
    agents: [
      {
        id: "c362f5e6-e982-47ab-bfbb-c31ca4bf152c",
        name: "UC2",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Demo Fallback Recovery"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
           baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "c362f5e6-e982-47ab-bfbb-c31ca4bf152c",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      },
      {
        id: "961b8f32-1a9d-4b24-be1a-dcc9b357d417",
        name: "UC1",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Demo Funnel Optimization"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "961b8f32-1a9d-4b24-be1a-dcc9b357d417",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      }
    ]
  },
  BambinosUcTest3: {
    path: "/bambinos-uc-test3",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "b5cf8bda-ec63-4a6a-b737-15a8886ecbac",
        name: "UC4",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Pulse Feedback Call"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "b5cf8bda-ec63-4a6a-b737-15a8886ecbac",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      },
      {
        id: "8ba0ec4f-607c-40f4-8233-c147cce6d99e",
        name: "UC3",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Onboarding and Welcome Call"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "8ba0ec4f-607c-40f4-8233-c147cce6d99e",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      }
    ]
  },
  BambinosUcTest4: {
    path: "/bambinos-uc-test4",
    pageTitle: "Experience Our Demo AI Agents",
    agents: [
      {
        id: "b5cf8bda-ec63-4a6a-b737-15a8886ecbac",
        name: "UC4",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Pulse Feedback Call"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
           baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "b5cf8bda-ec63-4a6a-b737-15a8886ecbac",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      },
      {
        id: "8ba0ec4f-607c-40f4-8233-c147cce6d99e",
        name: "UC3",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Onboarding and Welcome Call"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "8ba0ec4f-607c-40f4-8233-c147cce6d99e",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      }
    ]
  },
  TopRankers: {
    path: "/top-rankers",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "5f9076da-4eee-4ca4-85c0-39750d0c1080",
        name: "UC1",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Lead Qualification Agent"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "5f9076da-4eee-4ca4-85c0-39750d0c1080",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      },
      {
        id: "650caa18-adb3-4790-a79f-a95d2324d79d",
        name: "UC2",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Recovery Agent"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "650caa18-adb3-4790-a79f-a95d2324d79d",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      }
    ]
  },
  TopRankers1: {
    path: "/top-rankers1",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "5f9076da-4eee-4ca4-85c0-39750d0c1080",
        name: "UC1",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Lead Qualification Agent"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "5f9076da-4eee-4ca4-85c0-39750d0c1080",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      },
      {
        id: "650caa18-adb3-4790-a79f-a95d2324d79d",
        name: "UC2",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Recovery Agent"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "650caa18-adb3-4790-a79f-a95d2324d79d",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      }
    ]
  },
  Xanadu1: {
    path: "xanadu1",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "c9c0a466-4ae8-43f6-9f00-71e1bacf2bc7",
        name: "Xanadu Chat Agent",
        agentName: "Priya",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Languages: English, Hinglish, Hindi"],
        voice: "false",
        chat: "true",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },]
    },
    TopRankersLq: {
    path: "/top-rankers-lq",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "26698e84-8eae-489c-a712-204715bb3f52",
        name: "UC1",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Lead Qualification Agent"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "26698e84-8eae-489c-a712-204715bb3f52",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: "a7789bcc-365e-497d-891b-7a057b887103",
          workspace_id: "a7789bcc-365e-497d-891b-7a057b887103"
        }
      }
    ]
  },
  nurixLqDemo: {
    path: "nurix-lq-demo",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "a018cb85-a544-4d46-8e5d-90927d29bcf9",
        name: "Nuplay Demo",
        agentName: "Meera",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Lead Qualification Agent"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "a018cb85-a544-4d46-8e5d-90927d29bcf9",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      }
    ]
  },
  collegeVidya: {
    path: "college-vidya",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "746911b4-e883-4839-ae41-1f3246659a91",
        name: "Lead Qualification",
        agentName: "Priya",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Lead Qualification"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "746911b4-e883-4839-ae41-1f3246659a91",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID
        }
      }
    ]
  },
  school_selection_advisor: {
    path: "school-finder",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "4c05858b-5c78-4027-a657-5eaf69cb45c1",
        name: "School Selection Advisor",
        agentName: "Sarah",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [
          "Personalised school recommendations",
          "School comparison and analysis",
          "Curriculum guidance and explanation"
        ],
        voice: "false",
        chat: "true",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {}
      }
    ]
  },
  Vedantu: {
    path: "/vedantu",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "516cde4d-71b8-4fca-800a-9f76661d1cd8",
        name: "Vedantu Lead Qualification",
        agentName: "Vedika",
        icon: memoji3,
        chatIcon: memoji3Chat,
        featureList: ["Confirm lead details","Qualify leads based on conversation"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "516cde4d-71b8-4fca-800a-9f76661d1cd8",
          tenant_id: "40a6012b-0de0-4a35-a209-907cf4162d23",
          workspace_id: "40a6012b-0de0-4a35-a209-907cf4162d23",
          overide_previous_context: true
        }
      }
    ]
  },
  collegeVidya2: {
    path: "college-vidya2",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "ad98b9d8-99bf-47ad-85d3-5896e24c5203",
        name: "Lead Qualification",
        agentName: "CV Sara",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: ["Language: Hinglish", "Task : Lead Qualification"],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: OLD_USER_ID,
          agent_id: "ad98b9d8-99bf-47ad-85d3-5896e24c5203",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: "38c4c361-d003-4e4f-a359-ecfef8e65d55",
          workspace_id: "38c4c361-d003-4e4f-a359-ecfef8e65d55",
        }
      }
    ]
  },
  Livguard: {
    path: "/livguard2",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "d7de52b6-5734-45a6-83ec-6e7ef6655244",
        name: "Outbound Sales Agent",
        agentName: "Sonu",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Handles on-grid and off-grid customer needs.", "Explains process and pricing"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "5b490ed0-e3bd-4703-9313-04a980075e77-draft",
          tenant_id: "93debacb-6338-4fe3-befb-731e7fd94a3b",
          workspace_id: "93debacb-6338-4fe3-befb-731e7fd94a3b",
          overide_previous_context: true
        }
      }
    ]
  },
  CultFit2: {
    path: "cultfit_elite_pass",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "892a4a10-6f3e-424b-bbb5-0204ce087a20",
        name: "Customer Support Agent",
        agentName: "",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["Answers FAQs", "Provides Elite package offers to customers"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: ["phone"],
        voiceProvider: "outbound-call",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "892a4a10-6f3e-424b-bbb5-0204ce087a20",
          tenant_id: "1744b80d-1375-42ca-8f68-5e15e702bf6a",
          workspace_id: "1744b80d-1375-42ca-8f68-5e15e702bf6a",
          overide_previous_context: true
        }
      }
    ]
  },
  KarnavatiUni: {
    path: "karnavati-uni",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "dd5e2ae2-b2d6-465b-b489-b6a4288b156c",
        name: "Admission Counselling Agent",
        agentName: "Garima",
        icon: memoji2,
        chatIcon: memoji2Chat,
        featureList: ["Answers FAQs", "Provides admission counselling"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "dd5e2ae2-b2d6-465b-b489-b6a4288b156c",
          tenant_id: "3a060cae-8543-44a6-aba7-64600ec6b440",
          workspace_id: "3a060cae-8543-44a6-aba7-64600ec6b440",
          overide_previous_context: true
        }
      }
    ]
  },
};
